<template>
  <div>
    <p class="success-num">{{successBargainNum}}人已成功砍价</p>
    <div v-show="toastMsg">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <p class="weui-toast__content">{{toastMsg}}</p>
      </div>
    </div>

    <PopTips :tips-shown.sync="tipsShown" :bargain-info="bargainDetail"></PopTips>
    <div class="pop-bg" v-show="isZoneAndRoleSelectorShown || isLowestDiscountItemsShown">

      <!--绑定大区-->
      <div class="pop login-pop" v-show="isZoneAndRoleSelectorShown">
        <!--<div class="close" @click="hideZoneRole"></div>-->
        <div class="pops">
          <div class="title">
            <div class="line l-line"></div>
            绑定游戏角色<br>开启超爽砍价
            <div class="line r-line"></div>
          </div>
          <div class="content">
            <div class="form">
              <div class="list">
                <p class="label">渠道</p>
                <div class="select">
                  <select name="">
                    <option>{{userAgent.iOS?'iOS':'安卓'}}-{{loginState.sessionType=='wc_actoken'?'微信':'QQ'}}</option>
                  </select>
                </div>
              </div>
              <div class="list">
                <p class="label">大区</p>
                <div class="select">
                  <select name="" v-if="zoneInfo" v-model="selectedZoneInfo" @change="changeZone(selectedZoneInfo)">
                    <option disabled value="">请选择大区</option>
                    <option v-for="(zone,index) in zoneInfo" :key="index" :value="zone">{{zone.t}}</option>
                  </select>
                </div>
              </div>
              <div class="list" v-if="selectedRoleName">
                <p class="label">角色</p>
                <div class="select">
                  <select name="">
                    <option>{{selectedRoleName}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="btn comfirm-btn" @click="confirmSelectedZone"><p>确定</p></div>
        </div>
      </div>

      <!-- xxx英雄被爆砍一折弹窗 -->
      <div class="pop tips-pop cut-pop" v-show="isLowestDiscountItemsShown && lowestDiscountItems.length>0">
        <div class="close" @click="closeLowestDiscountItem"></div>
        <div class="title">
          <div class="line l-line"></div>
          温馨提示
          <div class="line r-line"></div>
        </div>
        <div class="content">
          <div class="txt">太棒了！<br>暴击已出现！<br>{{lowestDiscountItems.map(item=>item.product_name).join(',')}}已被砍至1折</div>
        </div>
        <a href="javascript:void 0" @click="goToLowerDiscountItem" class="btn buy-btn"><p>立即查看</p></a>
      </div>
    </div>

    <div :class="{end: isActivityExpired}">
      <div class="shop-box" v-if="isActivityExpired">
        <div class="tips-wrap">
          <img src="../../../ui/20190114/img/expression.png" alt="img">
          <div class="mess-wraps">
            <p class="text">本期活动已结束</p>
            <p class="text">感谢支持</p>
            <p class="text">下期再见哦～</p>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="mess-wrap">
          <div class="user-mess" style="height: 1.98rem;">
            <div class="left" v-if="!isInMSDK" @click="showZoneRole">
              <p class="game-add" v-if="selectedZone && selectedZone.sk">
                {{selectedZone.sk.toUpperCase()=='IOS'?'iOS':'安卓'}}{{selectedZone.t}}
              </p>
              <p class="user-me" v-if="selectedZone && selectedZone.sk">
                <em class="username">{{selectedRoleName}}</em>
                <span>[切换]</span>
              </p>
              <p v-else>
                <span>请选择大区角色</span>
              </p>
              <!--<span @click="showZoneRole" v-if="selectedZone && selectedZone.sk">-->
              <!--{{selectedZone.sk.toUpperCase()=='IOS'?'iOS':'安卓'}}{{selectedZone.t}} {{selectedRoleName}}<span>[切换]</span>-->
              <!--</span>-->
            </div>
            <div class="left" style="text-decoration: none;" v-else>
              <p class="game-add" v-if="selectedZoneInfo && selectedZoneInfo.sk">
                {{selectedZoneInfo.sk.toUpperCase()=='IOS'?'iOS':'安卓'}}{{selectedZoneInfo.t}}
              </p>
              <p class="user-me" v-if="selectedZoneInfo && selectedZoneInfo.sk && selectedRoleName">
                <em class="username">{{selectedRoleName}}</em>
              </p>
            </div>
            <div class="user-pic-box" v-show="!isInMSDK">
              <img :src="avatar" alt="img"/>
              <!-- qq登录 -->
              <div class="qq-icon" v-if="['skey','kp_accesstoken'].indexOf(loginState.sessionType)>-1"></div>
              <!-- wechar登录 -->
              <div class="wechat-icon" v-if="['wc_actoken'].indexOf(loginState.sessionType)>-1"></div>
            </div>
            <p class="rule" @click="showRuleDialog">活动规则</p>
          </div>
        </div>


<!--        <div class="step">-->
<!--          <img src="../../../ui/20190114/img/step.png" alt="img"/>-->
<!--        </div>-->
        <div class="shop-box"
             v-if="(myBargainList && myBargainList.length>0)">
          <div class="title">
            <div class="line l-line"></div>
            我的砍价背包
            <div class="line r-line"></div>
          </div>
          <div class="list-wrap">
            <ul>

              <li v-for="(item,index) in myBargainList" :key="'mybargain'+index">
                <div class="list">
                  <b
                    :class="{'a-status':item.bargain_status=='on','d-status':item.bargain_status=='off' && checkTimeValid(item.bargain_begin)}"></b>
                  <div class="border"></div>
                  <img :src="item.product_url" alt="img"/>
                  <p class="shop-name">
                    <span class="hero-name">{{item.product_name.split("-")[0]}}</span>
                    <br>
                    <span class="pifu-name">{{item.product_name.split("-")[1]||""}}</span>
                  </p>
                  <div class="mess-box">
                    <p class="original-price">原价：{{item.origin_amt/10}}</p>
                    <p class="min-price" v-if="item.bargain_status=='off'">支付价：<span>{{item.now_amt/10}}</span></p>
                    <p class="min-price" v-else>最低价：<span>{{item.least_amt/10}}</span></p>
                  </div>
                </div>

                <a href="javascript:void 0" v-if="item.bargain_status=='on'" @click="viewBargainDetail(item)"
                   class="shop-btn progress">
                  <p class="label">查看进度</p>
                  <p class="surplus" style="color:#cb3920;background: none;">
                    <CountDown :end-time="item.bargain_end"></CountDown>
                  </p>
                </a>
                <div v-if="item.bargain_status=='off' && checkTimeValid(item.bargain_begin)"
                     class="shop-btn buy now-buy-btn" @click="goToDetail(item)">
                  <p class="label" style="line-height: 0.62rem;">立即拥有</p>
                </div>
                <div v-if="item.bargain_status=='off' && !checkTimeValid(item.bargain_begin)" class="shop-btn overdue">
                  <p class="label">已过期</p>
                </div>
                <div class="shop-btn overdue" v-if="item.bargain_status=='over'">
                  <p class="label">已购买</p>
                </div>

              </li>


            </ul>
          </div>
        </div>


        <div class="shop-box surplus-box"
             v-show="(avaliableBargainList && avaliableBargainList.length>0)  || (ownedProductList && ownedProductList.length>0)">
          <div class="title">
            <div class="line l-line">
            </div>
            本期砍价列表
            <!--还能发起<span class="red">{{avaliableBargainList.length}}</span>次砍价-->
            <div class="line r-line"></div>
          </div>
          <p class="success-num" v-if="criticalStrikeNums>0">已有<span class="imp">{{criticalStrikeNums}}</span>人一折暴击价购买成功！</p>

          <div class="tab" v-if="avaliableBargainList && avaliableBargainList.length>0">
            <p @click="goToProductSlide(skinsDefaultIndex,'SKIN')" :class="{'on':(productSwiper.activeIndex< starSkinsDefaultIndex)}">皮肤</p>
            <p @click="goToProductSlide(starSkinsDefaultIndex,'STARSKIN')" :class="{'on':productSwiper.activeIndex<herosDefaultIndex && productSwiper.activeIndex>=starSkinsDefaultIndex}">星元皮肤</p>
            <p @click="goToProductSlide(herosDefaultIndex,'HERO')" :class="{'on':productSwiper.activeIndex>=herosDefaultIndex}">英雄</p>
          </div>
          <swiper id="product_swiper" :options="swiperOptions" ref="productSwiper">

              <swiper-slide
              v-for="(skinItem,skinIndex) in Math.ceil((skinsBargainList.length+skinsOwnedProductList.length)/6)"
              :key="'skinswiper'+skinIndex">
              <ul>
                <li
                    v-for="(item,index) in skinsBargainList"
                    v-if="index<(skinIndex+1)*6 && index>=skinIndex*6 && skinIndex<= Math.ceil(skinsBargainList.length/6)"
                    :key="'skin'+index">
                  <div class="list">
                    <div class="border"></div>
                    <img :src="item.product_url" alt="img"/>
                    <p class="shop-name">
                      <span class="hero-name">{{item.product_name.split("-")[0]}}</span>
                      <br>
                      <span class="pifu-name">{{item.product_name.split("-")[1]||""}}</span>
                    </p>
                    <div class="mess-box">
                      <p class="original-price">原价：{{item.origin_amt/10}}</p>
                      <p class="min-price">最低价：<span>{{item.least_amt/10}}</span></p>
                    </div>
                  </div>
                  <div class="shop-btn start-bargain" @click="startBargain(item,index)"><p class="label">立即开砍</p></div>
                </li>

                <li v-for="(item,index) in skinsOwnedProductList"
                    v-if="(skinsBargainList.length+index)<(skinIndex+1)*6 && (skinsBargainList.length+index)>=skinIndex*6 && skinIndex>~~(skinsBargainList.length/6)-1"
                    :key="'skinownedproduct'+item.product_id">
                  <div class="list">
                    <div class="border"></div>
                    <img :src="item.product_url" alt="img"/>
                    <p class="shop-name">
                      <span class="hero-name">{{item.product_name.split("-")[0]}}</span>
                      <br>
                      <span class="pifu-name">{{item.product_name.split("-")[1]||""}}</span>
                    </p>
                    <div class="mess-box">
                      <p class="original-price">原价：{{item.origin_amt/10}}</p>
                      <p class="min-price">最低价：<span>{{item.least_amt/10}}</span></p>
                    </div>
                  </div>

                  <div class="shop-btn have">
                    <p class="label">已拥有</p>
                  </div>

                </li>

              </ul>
            </swiper-slide>

              <swiper-slide
              v-for="(starSkinItem,starSkinIndex) in Math.ceil((starSkinsBargainList.length+starSkinsOwnedProductList.length)/6)"
              :key="'starskinswiper'+starSkinIndex">
              <ul>
                <li
                    v-for="(item,index) in starSkinsBargainList"
                    v-if="index<(starSkinIndex+1)*6 && index>=starSkinIndex*6 && starSkinIndex<= Math.ceil(starSkinsBargainList.length/6)"
                    :key="'starskin'+index">
                  <div class="list">
                    <div class="border"></div>
                    <img :src="item.product_url" alt="img"/>
                    <p class="shop-name">
                      <span class="hero-name">{{item.product_name.split("-")[0]}}</span>
                      <br>
                      <span class="pifu-name">{{item.product_name.split("-")[1]||""}}</span>
                    </p>
                    <div class="mess-box">
                      <p class="original-price">原价：{{item.origin_amt/10}}</p>
                      <p class="min-price">最低价：<span>{{item.least_amt/10}}</span></p>
                    </div>
                  </div>
                  <div class="shop-btn start-bargain" @click="startBargain(item,index)"><p class="label">立即开砍</p></div>
                </li>

                <li v-for="(item,index) in starSkinsOwnedProductList"
                    v-if="(starSkinsBargainList.length+index)<(starSkinIndex+1)*6 && (starSkinsBargainList.length+index)>=starSkinIndex*6 && starSkinIndex>~~(starSkinsBargainList.length/6)-1"
                    :key="'starSkinownedproduct'+item.product_id">
                  <div class="list">
                    <div class="border"></div>
                    <img :src="item.product_url" alt="img"/>
                    <p class="shop-name">
                      <span class="hero-name">{{item.product_name.split("-")[0]}}</span>
                      <br>
                      <span class="pifu-name">{{item.product_name.split("-")[1]||""}}</span>
                    </p>
                    <div class="mess-box">
                      <p class="original-price">原价：{{item.origin_amt/10}}</p>
                      <p class="min-price">最低价：<span>{{item.least_amt/10}}</span></p>
                    </div>
                  </div>

                  <div class="shop-btn have">
                    <p class="label">已拥有</p>
                  </div>

                </li>

              </ul>
            </swiper-slide>

              <swiper-slide
              v-for="(herosItem,herosIndex) in Math.ceil((herosBargainList.length+herosOwnedProductList.length)/6)"
              :key="'herosswiper'+herosIndex">
              <ul>
                <li
                    v-for="(item,index) in herosBargainList"
                    v-if="index<(herosIndex+1)*6 && index>=herosIndex*6 && herosIndex<= Math.ceil(herosBargainList.length/6)"
                    :key="'heros'+index">
                  <div class="list">
                    <div class="border"></div>
                    <img :src="item.product_url" alt="img"/>
                    <p class="shop-name">
                      <span class="hero-name">{{item.product_name.split("-")[0]}}</span>
                      <br>
                      <span class="pifu-name">{{item.product_name.split("-")[1]||""}}</span>
                    </p>
                    <div class="mess-box">
                      <p class="original-price">原价：{{item.origin_amt/10}}</p>
                      <p class="min-price">最低价：<span>{{item.least_amt/10}}</span></p>
                    </div>
                  </div>
                  <div class="shop-btn start-bargain" @click="startBargain(item,index)"><p class="label">立即开砍</p></div>
                </li>

                <li v-for="(item,index) in herosOwnedProductList"
                    v-if="(herosBargainList.length+index)<(herosIndex+1)*6 && (herosBargainList.length+index)>=herosIndex*6 && herosIndex>~~(herosBargainList.length/6)-1"
                    :key="'heorsownedproduct'+item.product_id">
                  <div class="list">
                    <div class="border"></div>
                    <img :src="item.product_url" alt="img"/>
                    <p class="shop-name">
                      <span class="hero-name">{{item.product_name.split("-")[0]}}</span>
                      <br>
                      <span class="pifu-name">{{item.product_name.split("-")[1]||""}}</span>
                    </p>
                    <div class="mess-box">
                      <p class="original-price">原价：{{item.origin_amt/10}}</p>
                      <p class="min-price">最低价：<span>{{item.least_amt/10}}</span></p>
                    </div>
                  </div>

                  <div class="shop-btn have">
                    <p class="label">已拥有</p>
                  </div>

                </li>

              </ul>
            </swiper-slide>
              <!-- Add Pagination -->
              <div class="swiper-pagination pagination swiper-pagination-bullets" slot="pagination"></div>
              <!-- Add Arrows -->
              <div class="swiper-button-next next" slot="button-prev" style="outline:none;" @click="goPrev"></div>
              <div class="swiper-button-prev prev" slot="button-next" style="outline:none;" @click="goNext"></div>
          </swiper>



          <!--          <div class="list-wrap">-->
          <!--            <ul>-->
          <!--              <li @click="startBargain(item,index)" v-for="(item,index) in avaliableBargainList" :key="index">-->
          <!--                <div class="list">-->
          <!--                  <div class="border"></div>-->
          <!--                  <img :src="item.product_url" alt="img"/>-->
          <!--                  <p class="shop-name">{{item.product_name}}</p>-->
          <!--                  <div class="mess-box">-->
          <!--                    <p class="original-price">原价：{{item.origin_amt/10}}</p>-->
          <!--                    <p class="min-price">最低价：<span>{{item.least_amt/10}}</span></p>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--                <div class="shop-btn start-bargain"><p class="label">立即开砍</p></div>-->
          <!--              </li>-->

          <!--              <li v-for="item in ownedProductList" :key="'ownedproduct'+item.product_id">-->
          <!--                <div class="list">-->
          <!--                  <div class="border"></div>-->
          <!--                  <img :src="item.product_url" alt="img"/>-->
          <!--                  <p class="shop-name">{{item.product_name}}</p>-->
          <!--                  <div class="mess-box">-->
          <!--                    <p class="original-price">原价：{{item.origin_amt/10}}</p>-->
          <!--                    <p class="min-price">最低价：<span>{{item.least_amt/10}}</span></p>-->
          <!--                  </div>-->
          <!--                </div>-->

          <!--                <div class="shop-btn have">-->
          <!--                  <p class="label">已拥有</p>-->
          <!--                </div>-->

          <!--              </li>-->

          <!--            </ul>-->
          <!--          </div>-->
        </div>
      </div>
    </div>


    <div class="footer">
      <div class="box">
        <div class="people people3"></div>
        <div class="mess">
<!--          <p><a class="link" @click="goToLuckDraw" href="javascript:void 0;">砍价成功,快来夺宝GO</a></p>-->
          <p>关注【腾讯充值】公众号</p>
          <p>第一时间知道砍价结果</p>
        </div>
        <div v-if="pf!='__mds_client_activity.bargain_wzry'">
          <div class="code" v-if="loginState.sessionType=='wc_actoken'">
            <img src="../../../ui/20190114/img/txcz_wzrybargain_scan.png" alt="img"/></div>
          <div class="code" v-else>
            <img src="../../../ui/20190114/img/qrcode_qq.jpg" alt="img"/>
          </div>
        </div>
      </div>
    </div>


    <div class="pop-bg line-up-wrap" id="busy_queue" v-show="isPageBusy">
      <div class="line-up">
        <div class="step"><p><span id="busy_progress">0</span>%</p></div>
        <p class="tips">哎呀，活动太火爆啦，正在排队进入。。。</p>
        <div class="btn again-btn" @click="retryLoadInfo"><p>重新进入</p></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex"
import PopTips from "./PopTips.vue"
import CountDown from "../bargain/pages/components/CountDown.vue"
import localStorage from "../bargain/utils/localStorage"
import * as configs from "./config"
import * as url from "../bargain/utils/url"
import * as request from "../bargain/utils/request"
import Raven from "raven-js"
import { swiper, swiperSlide } from "vue-awesome-swiper"

function init(vm) {
  vm.getLoginState()
    .then(loginState => {
      if (!vm.isInMSDK) {
        //游戏外
        let defaultSelectedZone = localStorage.get(`wzry_bargain_${vm.offerId}_${loginState.openid}`, true)
        if (!defaultSelectedZone) {
          //本地缓存没有用户选过的大区
          Promise.all([vm.showZoneRole(), vm.getUserRecommendZone()]).then(results => {
            if (results[1].recomm_info && results[1].recomm_info.part) {
              vm.selectedZoneInfo = vm.zoneInfo.filter(zone => {
                return zone.v == results[1].recomm_info.part
              })[0]
              vm.changeZone(vm.selectedZoneInfo)
            } else {
              vm.hasNoRoles = true
            }
          })
        } else {
          vm.setSelectedZone(defaultSelectedZone)
          vm.selectedZoneInfo = defaultSelectedZone

          vm.changeZone(defaultSelectedZone)
          getBargainList(vm)
        }
      } else {
        vm.getZoneInfo().then(zones => {
          let currentPartition = url.getParam("partition")
          vm.selectedZoneInfo = zones.filter(zone => {
            return zone.v == currentPartition
          })[0]

          vm.getRoleInfo({ platformId: vm.selectedZoneInfo.s, area: vm.selectedZoneInfo.c, zoneid: vm.selectedZoneInfo.v }).then(res => {
            let roles = decodeURIComponent(res.role_list).split(";"),
              rolesArr = []
            roles.forEach(item => {
              if (item) {
                let role = item.split(":")
                if (role[0] && role[1]) {
                  rolesArr.push({ name: role[1], id: role[0] })
                }
              }
            })
            if (rolesArr.length > 0) {
              vm.selectedRoleName = rolesArr[0].name
            }
          })
        })

        getBargainList(vm)
      }
      vm.queryCriticalStrike()
        .then(res => {
          if (res.info) {
            vm.criticalStrikeNums = res.info.baoji_times
          }
        })
        .catch(res => {
          Raven.captureBreadcrumb({
            message: "query-critical-strike-error",
            category: "query-critical-strike-error",
            data: {
              res
            }
          })
        })
      //
    })
    .catch(e => {
      Raven.captureException(new Error("get-login-state-error"), {
        tags: { type: "get-login-state-error" },
        extra: {
          e,
          getters: vm.$store.getters,
          rootState: vm.$store.state
        }
      })

      startBusyQueue(vm)
    })
    .then(() => {
      vm.reportUserAction({
        iformat: configs.REPORT.PAGEVIEW.HOMEPAGE
      })
    })
}

function getBargainList(vm) {
  Promise.all([
    vm.getMyBargains(),
    vm.getAllBargainList({
      game_platform_id: 1,
      gameid: [vm.selectedZone.c, "", "", vm.selectedZone.v].join("_")
    })
  ])
    .then(results => {
      if (results[0] && results[0].length > 0) {
        vm.myBargainList = results[0].sort((a, b) => {
          if (a.bargain_status == "off") {
            return -1
          } else if (a.bargain_status == "on") {
            if (b.bargain_status == "off") {
              return 1
            } else if (b.bargain_status == "over") {
              return -1
            }
          } else if (a.bargain_status == "over") {
            return 1
          }
        })
        vm.lowestDiscountItems = vm.myBargainList.filter(item => {
          return item.now_amt < item.least_amt && item.bargain_status == "off"
        })
        if (vm.lowestDiscountItems.length > 0) {
          vm.isLowestDiscountItemsShown = true
          vm.reportUserAction({
            iformat: configs.REPORT.PAGEVIEW.OPENER_BAOJI_POPUP
          })
        }
      } else {
        vm.hasNoMyBargains = true
      }

      // "" ：表示可以购买
      // 2310：表示已经拥有这个物品
      // 2311：没有对应英雄
      // 2311，2310：没有对应英雄并且有这个物品
      // 2312：表示星元皮肤依赖的皮肤没有
      document.querySelector("#product_swiper .swiper-wrapper").classList.add("list-wrap")
      // vm.productSwiper.update()
      if (results[1] && results[1].length > 0) {
        vm.avaliableBargainList = results[1].filter(item => {
          return (
            (!item.filter_info || item.filter_info.indexOf("2310") == -1) &&
            !vm.myBargainList.some(my => {
              return my.product_id == item.product_id
            })
          )
        })

        vm.skinsBargainList = vm.avaliableBargainList.filter(
          item => item.product_ext.indexOf("ItemType=13") > -1 && item.product_ext.indexOf("RelyItemType=13") == -1
        )
        vm.herosBargainList = vm.avaliableBargainList.filter(item => item.product_ext.indexOf("ItemType=10") > -1)
        vm.starSkinsBargainList = vm.avaliableBargainList.filter(
          item => item.product_ext.indexOf("ItemType=13") > -1 && item.product_ext.indexOf("RelyItemType=13") > -1
        )

        vm.ownedProductList = results[1].filter(item => {
          return (
            item.filter_info.indexOf("2310") > -1 &&
            !vm.myBargainList.some(my => {
              // 已有用的物品表示原来就在游戏中拥有，而不是当前在砍价活动中购买,因此需要排除掉已支付的物品
              return my.product_id == item.product_id && my.bargain_status == "over"
            })
          )
        })
        vm.skinsOwnedProductList = vm.ownedProductList.filter(
          item => item.product_ext.indexOf("ItemType=13") > -1 && item.product_ext.indexOf("RelyItemType=13") == -1
        )
        vm.herosOwnedProductList = vm.ownedProductList.filter(item => item.product_ext.indexOf("ItemType=10") > -1)
        vm.starSkinsOwnedProductList = vm.ownedProductList.filter(
          item => item.product_ext.indexOf("ItemType=13") > -1 && item.product_ext.indexOf("RelyItemType=13") > -1
        )
        //计算皮肤英雄对应swiper的索引
        vm.skinsDefaultIndex = 0
        vm.starSkinsDefaultIndex = Math.ceil((vm.skinsBargainList.length + vm.skinsOwnedProductList.length) / 6)
        vm.herosDefaultIndex =
          Math.ceil((vm.skinsBargainList.length + vm.skinsOwnedProductList.length) / 6) +
          Math.ceil((vm.starSkinsBargainList.length + vm.starSkinsOwnedProductList.length) / 6)

        if (vm.avaliableBargainList && vm.avaliableBargainList.length > 0) {
          let productInfo = []
          vm.avaliableBargainList.forEach((item, index) => {
            productInfo.push(`${index + 1}=${item.product_id}`)
          })
          vm.reportUserAction({
            iformat: configs.REPORT.PAGEVIEW.BARGAIN_PRODUCTS_SUCCESS,
            resultInfo: productInfo.join("&")
          })
        }
      } else {
        vm.hasNoActivityBargainList = true
        vm.reportUserAction({
          iformat: configs.REPORT.PAGEVIEW.ACTIVITY_END
        })
      }
    })
    .catch(res => {
      if (res && res.ret == 1414) {
        vm.isActivityExpired = true
      } else {
        Raven.captureException(new Error("get-bargain-list-error"), {
          tags: { type: "get-bargain-list-error" },
          extra: {
            res,
            getters: vm.$store.getters,
            rootState: vm.$store.state
          }
        })
        startBusyQueue(vm)
      }
    })
}

function startBusyQueue(vm) {
  request.getScript("//midas.gtimg.cn/midash5/js/lib/jquery-3.3.2.min.js").then(() => {
    //排队等待页，数字跳动效果
    $.fn.numberRock = function(options) {
      var defaults = {
        lastNumber: 100,
        duration: 2000,
        easing: "swing"
      }
      var opts = $.extend({}, defaults, options)

      $(this).animate(
        {
          num: "numberRock"
          // width : 300,
          // height : 300,
        },
        {
          duration: opts.duration,
          easing: opts.easing,
          complete: function() {
            $(".line-up-wrap .line-up .again-btn").show()
          },
          step: function(a, b) {
            $("#busy_progress").text(parseInt(b.pos * opts.lastNumber))
          }
        }
      )
    }

    vm.isPageBusy = true
    $(".line-up-wrap .line-up .step p span").numberRock({
      lastNumber: 100,
      duration: 10000,
      easing: "swing"
    })
  })
  vm.reportUserAction({
    iformat: configs.REPORT.PAGEVIEW.BUSY_QUEUE
  })
}

export default {
  name: "Index",
  components: {
    PopTips,
    CountDown,
    swiper,
    swiperSlide
  },
  data() {
    return {
      tipsShown: {
        isBuyPromptShown: false,
        isRuleShown: false,
        isWechatShareGuideShown: false,
        isPaySuccess: false,
        startBargainErrorMsg: "",
        isPayErrorMsg: "",
        isPlaceOrderErrorMsg: ""
      },
      isPageBusy: false,
      bargainDetail: {
        price: 25,
        name: "潮流闲人"
      },
      hasNoMyBargains: false,
      hasNoActivityBargainList: false,
      bargainSuccessNum: 0,
      myBargainList: [],
      avaliableBargainList: [],
      skinsBargainList: [],
      herosBargainList: [],
      starSkinsBargainList: [],
      ownedProductList: [],
      skinsOwnedProductList: [],
      herosOwnedProductList: [],
      starSkinsOwnedProductList: [],
      skinsDefaultIndex: "",
      starSkinsDefaultIndex: "",
      herosDefaultIndex: "",
      toastMsg: "",
      zoneInfo: "",
      selectedZoneInfo: "",
      selectedRoleName: "",
      hasNoRoles: false,
      isZoneAndRoleSelectorShown: false,
      firstOpenBargainPrice: 0, //首砍价格
      openBargainInitialCountDownHours: 1, //开砍后初始倒计时
      isActivityExpired: false,
      isLowestDiscountItemsShown: false, //是否有暴击的商品
      lowestDiscountItems: [],
      selectedSwiperIndex: 0,
      swiperOptions: {
        // wrapperClass: "list-wrap swiper-wrapper",
        // init: false,
        width: window.innerWidth,
        pagination: {
          el: ".pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".next",
          prevEl: ".prev"
        }
      },
      criticalStrikeNums: ""
    }
  },
  mounted() {
    // this.productSwiper.update()
    this.setOnShareHandler({ page: "index" })
  },
  computed: {
    productSwiper() {
      return this.$refs.productSwiper.swiper
    },
    ...mapState(["isInMSDK", "userAgent", "avatar", "pf"]),
    ...mapGetters(["loginState", "selectedZone", "successBargainNum", "offerId"])
  },
  beforeRouteEnter: (to, from, next) => {
    next(init)
  },
  methods: {
    ...mapActions([
      "getLoginState",
      "getMyBargains",
      "getAllBargainList",
      "getZoneInfo",
      "openBargain",
      "showMqqShareMenu",
      "getRoleInfo",
      "setSelectedZone",
      "getUserRecommendZone",
      "reportUserAction",
      "setOpenerFirstBargain",
      "setOpenerBargainDialog",
      "setFirstBargainInfo",
      "placeOrder",
      "setOnShareHandler",
      "sendQualification",
      "queryCriticalStrike"
    ]),
    showRuleDialog() {
      this.tipsShown.isRuleShown = true
      this.reportUserAction({
        iformat: configs.REPORT.PAGEVIEW.RULE
      })
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.SHOW_RULE
      })
    },
    startBargain(item, index) {
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.START_BARGAIN,
        resultInfo: `${index + 1}=${item.product_id}`
      })
      //判断用户有没有选大区
      if (this.selectedZone) {
        this.openBargain({
          productId: item.product_id,
          extendParams: {
            cgi_info: `gameid=${[this.selectedZone.c, "", "", this.selectedZone.v].join("_")}&zoneid=${this.selectedZone.v}`
          }
        })
          .then(info => {
            // this.isBargainStarted = true
            // this.firstOpenBargainPrice = info.reduce_amt / 10
            // this.openBargainInitialCountDownHours = item.bargain_time.replace(/[+H]/gi, "")
            // this.sendQualification(configs.SEND_QUALIFICATION_GROUPID.OPEN)
            this.setFirstBargainInfo({
              bargainId: info.bargain_id,
              price: info.reduce_amt / 10,
              countdown: item.bargain_time.replace(/[+H]/gi, ""),
              item
            })
            this.setOpenerBargainDialog(true)
            this.reportUserAction({
              iformat: configs.REPORT.PAGEVIEW.OPENER_PROMPT,
              resultInfo: `bargain_id=${info.bargain_id}`
            })
            this.$router.push(`/open/${info.bargain_id}/${this.offerId}`)
          })
          .catch(res => {
            if (res.err_code.indexOf("1132-81005") > -1) {
              //单用户单商品,用户还有进行的商品砍价活动
              this.tipsShown.startBargainErrorMsg = `每个用户限发起${res.limit_times}次砍价，你已超过次数。`
            } else if (res.err_code.indexOf("1132-81006") > -1) {
              //单用户单商品,用户没有进行的商品砍价活动

              this.tipsShown.startBargainErrorMsg = `每个用户限发起${res.limit_times}次砍价，`
            } else if (res.err_code.indexOf("1132-81007") > -1) {
              //单用户所有商品,用户有进行的商品砍价活动
              this.tipsShown.startBargainErrorMsg = "当前商品已有正在进行的砍价，"
            } else if (res.err_code.indexOf("1132-81008") > -1) {
              //单用户所有商品,用户没有进行的商品砍价活动
              this.tipsShown.startBargainErrorMsg = `每个用户限发起${res.limit_times}次砍价，`
            } else {
              this.tipsShown.startBargainErrorMsg = `系统繁忙，请稍候再试！(${res.err_code || res.ret})`
            }

            this.reportUserAction({
              iformat: configs.REPORT.CLICK.START_BARGAIN_FAILURE
            })
          })
      } else {
        this.showZoneRole()
      }
    },
    goToDetail(item) {
      this.$router.push(`/open/${item.bargain_id}/${this.offerId}`)
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.INDEX_BARGAIN_BUY_NOW
      })
    },
    showBuyPrompt(item) {
      let params = {
        extendParams: {
          zoneid: url.getParam("zoneid", decodeURIComponent(item.cgi_info)),
          is_filter_goods: 1,
          change_openid: 1,
          change_wx_openid: this.loginState.sessionType == "wc_actoken" && this.userAgent.weixin ? 1 : 0
        },
        gameId: url.getParam("gameid", decodeURIComponent(item.cgi_info)),
        productId: item.product_id,
        productNum: item.product_num,
        productName: item.product_name
      }
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.BARGAIN_DETAIL_BUY
      })

      this.placeOrder(params)
        .then(res => {
          this.bargainDetail = {
            price: item.now_amt / 10,
            name: item.product_name,
            logo: item.product_url,
            token: res.token,
            bargainId: item.bargain_id,
            billNo: item.bill_no,
            mid: res.mid,
            offerId: this.offerId
          }

          if (res.filter_info && res.filter_info[item.product_id]) {
            if (res.filter_info[item.product_id].indexOf("2310") > -1) {
              //用户已拥有该物品
              this.tipsShown.isPlaceOrderErrorMsg = "您已拥有该物品！"
            } else if (res.filter_info[item.product_id].indexOf("2311") > -1) {
              //用户没有该英雄
              this.bargainDetail.buyPromptMsg = "注意：您现在还未拥有该英雄，先拥有英雄后才可以体验皮肤哦"
              // this.tipsShown.isPlaceOrderErrorMsg = "您还没有该英雄！"
              this.tipsShown.isBuyPromptShown = true
            }
          } else {
            this.tipsShown.isBuyPromptShown = true
          }
        })
        .catch(res => {
          this.tipsShown.isPlaceOrderErrorMsg = res.msg || `系统繁忙，请稍候再试！(${res.ret})`
        })
    },
    viewBargainDetail(item) {
      this.$router.push(`/open/${item.bargain_id}/${this.offerId}`)
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.VIEW_BARGAIN_DETAIL
      })
    },
    showZoneRole() {
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.CHOOSE_ZONE
      })
      this.reportUserAction({
        iformat: configs.REPORT.PAGEVIEW.CHANGE_ZONE
      })
      return this.getZoneInfo().then(zones => {
        let os = "",
          account = ""
        if (this.userAgent.weixin) {
          account = "weixin"
        } else if (this.userAgent.QQ) {
          account = "qq"
        }

        if (this.userAgent.iOS) {
          os = "ios"
        } else if (this.userAgent.android) {
          os = "android"
        }
        this.zoneInfo = zones.filter(zone => {
          let result
          if (zone.status == 1 && (zone.sk && zone.sk == os) && (zone.ck && zone.ck == account) && zone.c != 6 && zone.c != 7) {
            //手游
            result = true
          }
          return result
        })
        this.isZoneAndRoleSelectorShown = true
      })
    },
    changeZone(zone) {
      this.hasNoRoles = true
      this.selectedRoleName = ""
      this.getRoleInfo({ platformId: zone.s, area: zone.c, zoneid: zone.v })
        .then(res => {
          let roles = decodeURIComponent(res.role_list).split(";"),
            rolesArr = []
          roles.forEach(item => {
            if (item) {
              let role = item.split(":")
              if (role[0] && role[1]) {
                rolesArr.push({ name: role[1], id: role[0] })
              }
            }
          })
          if (rolesArr.length == 0) {
            this.hasNoRoles = true
            this.toastMsg = "你在此区无游戏角色"
            setTimeout(() => {
              this.toastMsg = null
            }, 2000)
            return
          } else {
            this.hasNoRoles = false
            this.selectedRoleName = rolesArr[0].name
          }
        })
        .catch(res => {
          if (res.ret == 1220) {
            this.toastMsg = "你在此区无游戏角色"
          } else {
            this.toastMsg = res.msg || "查询角色系统繁忙，请稍候再试！"
          }
          setTimeout(() => {
            this.toastMsg = null
          }, 2000)
          this.hasNoRoles = true
          this.selectedRoleName = ""
        })
    },
    confirmSelectedZone() {
      if (!this.hasNoRoles && this.selectedZoneInfo && this.selectedZoneInfo.v) {
        this.setSelectedZone(this.selectedZoneInfo)
        getBargainList(this)
        this.hideZoneRole()
      } else {
        this.toastMsg = "请选择有角色的大区"
        setTimeout(() => {
          this.toastMsg = null
        }, 2000)
      }
    },
    hideZoneRole() {
      this.isZoneAndRoleSelectorShown = false
    },
    checkTimeValid(begainTime) {
      //如果当前时间已经超出小砍开始时间七天,则认为该笔小砍已过期
      let now = new Date().getTime()
      let begin = new Date(begainTime * 1000).getTime()
      if (now - begin <= 7 * 24 * 3600 * 1000 && now > begin) {
        return true
      } else {
        return false
      }
    },
    retryLoadInfo() {
      init(this)
      this.isPageBusy = false
      $(".line-up-wrap .line-up .again-btn").hide()
    },
    goToLuckDraw() {
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.HELPER_WANT_LUCKY_DRAW
      })
      let new_url = url.delParam(["pf"], location.href)
      let queryStr = new_url.split("?")[1] || ""
      location.href = `${configs.LUCKY_DRAW_URL}&partition=${this.selectedZone.v}&${queryStr}`
    },
    closeLowestDiscountItem() {
      this.isLowestDiscountItemsShown = false
    },
    goToLowerDiscountItem() {
      if (this.lowestDiscountItems.length > 0) {
        if (this.lowestDiscountItems.length == 1) {
          this.$router.push(`/open/${this.lowestDiscountItems[0].bargain_id}/${this.offerId}`)
        }
        this.reportUserAction({
          iformat: configs.REPORT.CLICK.OPENER_BAOJI_VIEW_DETAIL
        })
        this.isLowestDiscountItemsShown = false
      }
    },
    goToProductSlide(index, TYPE) {
      this.productSwiper.slideTo(index)
      this.reportUserAction({
        iformat: configs.REPORT.CLICK[`LIST_${TYPE}`]
      })
    },
    goPrev() {
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.GOODS_LEFT
      })
    },
    goNext() {
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.GOODS_RIGHT
      })
    }
  }
}
</script>

<style scoped>
</style>
